<template>
  <p>
    {{ t('enumMap.SpotMarketExceptionReason.MISSING_EMAIL', { carrierName }) }}

    <i18n-t
      v-if="authorization.hasAuthority('client', 'manageCarriers')"
      keypath="carrierPortal.spotMarket.addEmailConfig"
      tag="span"
    >
      <template #homePageLink>
        <a :href="ficonHomeUrl">
          {{ t('carrierPortal.spotMarket.addEmailConfigLinkText') }}
        </a>
      </template>
    </i18n-t>
  </p>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import authorization from '@rygen/rygen-ui/authorization';
import { Module } from '@rygen/rygen-ui/model';
import { generateAppUrl } from '@rygen/rygen-ui/util';

import { Carrier } from '@/model';
import { useCurrentUserStore } from '@/stores/CurrentUser';

const props = defineProps({
  carrier: {
    type: Object as PropType<Carrier>,
    default: () => new Carrier(),
  },
});
const { carrier } = toRefs(props);

const { t } = useI18n();
const { selectedDomain } = useCurrentUserStore();

const carrierName = computed(
  () => `${carrier.value.name} (${carrier.value.scac})`,
);

const ficonHomeUrl = computed(() =>
  generateAppUrl(Module.FICON, '', selectedDomain.value?.naturalId),
);
</script>
